module.exports = __webpack_public_path__ + "img/foot1.b98af35b.png";